<template>
  <svg
    viewBox="0 0 24 24"
    class="h-full w-full"
  >
    <defs>
      <linearGradient
        id="strokeGradient"
        x1="0%"
        y1="0%"
        x2="100%"
        y2="0%"
      >
        <stop
          offset="0%"
          style="stop-color: #2E2E2E"
        />
        <stop
          offset="100%"
          style="stop-color: #AAAAAA"
        />
      </linearGradient>
    </defs>
    <path 
      fill="none"
      :stroke="useGradient ? 'url(#strokeGradient)' : 'currentColor'"
      stroke-width="1.5"
      d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM12 8l4 4m0 0l-4 4m4-4H8"
    />
  </svg>
</template>

<script setup>
defineProps({
    useGradient: {
        type: Boolean,
        default: false
    }
});
</script>
